var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.input.componentName,{tag:"component",attrs:{"input":_vm.input,"disabled":_vm.disabled,"multiple":_vm.multiple,"error-messages":_vm.errorMessages},on:{"update:value":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }